import { useIntl } from 'react-intl';

import { routes } from 'utils/routing';

export const useLocalizedUrls = () => {
  const { formatMessage } = useIntl();

  return {
    rollUpTheRimLandingPageUrl: formatMessage({
      id: 'routes.rollUpTheRim',
      defaultMessage: routes.rollUpTheRim,
    }),
    rollUpTheRimRulesUrl: formatMessage({
      id: 'routes.rollUpTheRimRules',
      defaultMessage: routes.rollUpTheRimRules,
    }),
    rollUpTheRimSharedRolls: formatMessage({
      id: 'routes.rollUpTheRimSharedRolls',
      defaultMessage: routes.rollUpTheRimSharedRolls,
    }),
    rollUpTheRimToWin: formatMessage({
      id: 'routes.rollUpTheRimToWin',
      defaultMessage: routes.rollUpTheRimToWin,
    }),
  };
};
